import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/sidebar.css';

export default function Sidebar({ isOpen, toggleSidebar, onNavClick }) {
  const location = useLocation();
  const [sendSmsOpen, setSendSmsOpen] = useState(false);

  const handleNavClick = () => {
    if (onNavClick) {
      onNavClick();
    }
  };

  const isActive = (path) => location.pathname === path;
  const isParentActive = (paths) => paths.some(p => location.pathname === p);

  return (
    <aside className={`sidebar ${isOpen ? 'open' : ''} ${!isOpen ? 'closed' : ''}`}>
      <div className="sidebar-header">
        <button className="sidebar-toggle" onClick={toggleSidebar}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>
      </div>

      <nav className="sidebar-nav">
        <Link
          to="/dashboard"
          onClick={handleNavClick}
          className={`nav-item ${isActive('/dashboard') ? 'active' : ''}`}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="3" width="7" height="7" />
            <rect x="14" y="3" width="7" height="7" />
            <rect x="14" y="14" width="7" height="7" />
            <rect x="3" y="14" width="7" height="7" />
          </svg>
          <span>Dashboard</span>
        </Link>

        <Link
          to="/dashboard/contacts"
          onClick={handleNavClick}
          className={`nav-item ${isActive('/dashboard/contacts') ? 'active' : ''}`}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
          <span>Contacts</span>
        </Link>

        <div className="nav-group">
          <button
            className={`nav-item nav-parent ${isParentActive(['/dashboard/send-bulk-sms', '/dashboard/send-single-sms']) ? 'active' : ''}`}
            onClick={() => setSendSmsOpen(!sendSmsOpen)}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
            <span>Send SMS</span>
            <svg className={`chevron ${sendSmsOpen ? 'open' : ''}`} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          {sendSmsOpen && (
            <div className="nav-submenu">
              <Link
                to="/dashboard/send-bulk-sms"
                className={`nav-subitem ${isActive('/dashboard/send-bulk-sms') ? 'active' : ''}`}
              >
                Send Bulk SMS
              </Link>
            </div>
          )}
        </div>

        <Link
          to="/dashboard/templates"
          onClick={handleNavClick}
          className={`nav-item ${isActive('/dashboard/templates') ? 'active' : ''}`}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
            <path d="M7 7h10M7 11h10M7 15h4" />
          </svg>
          <span>Templates</span>
        </Link>

        <Link
          to="/dashboard/reports"
          onClick={handleNavClick}
          className={`nav-item ${isActive('/dashboard/reports') ? 'active' : ''}`}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="12" y1="2" x2="12" y2="22" />
            <path d="M17 5H9.5a1.5 1.5 0 0 0 0 3h5a1.5 1.5 0 0 1 0 3h-5.5" />
            <path d="M6 12h12" />
            <path d="M6 17h12" />
          </svg>
          <span>Reports</span>
        </Link>

        <hr className="sidebar-divider" />

        <Link
          to="/dashboard/profile"
          onClick={handleNavClick}
          className={`nav-item ${isActive('/dashboard/profile') ? 'active' : ''}`}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
          <span>Profile</span>
        </Link>

        <Link
          to="/dashboard/settings"
          onClick={handleNavClick}
          className={`nav-item ${isActive('/dashboard/settings') ? 'active' : ''}`}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="3" />
            <path d="M12 1v6m0 6v6M4.22 4.22l4.24 4.24m5.08 5.08l4.24 4.24M1 12h6m6 0h6M4.22 19.78l4.24-4.24m5.08-5.08l4.24-4.24" />
          </svg>
          <span>Settings</span>
        </Link>
      </nav>
    </aside>
  );
}
